import { IntlShape } from 'gatsby-plugin-intl';

export const makeFormatter = (intlShape: IntlShape, prefix?: string) => (
  id: string
) =>
  intlShape.formatMessage({
    id: prefix === undefined ? id : [prefix, id].join('.')
  });
